import { createSlice } from "@reduxjs/toolkit";
import { createValuePreparer } from "./reduxUtils";

const initialState = {
  filterByUserId: null,
  logInUser:{}
};

const users = createSlice({
  name: "users",
  initialState,
  reducers: {
    filterUser: {
      prepare: createValuePreparer("filterByUserId"),
      reducer(state, action) {
        state.filterByUserId = action.payload.filterByUserId;
      },
    },
    user: {
      prepare: createValuePreparer("user"),
      reducer(state, action) {
        state.logInUser = action.payload.user;
      },
    },
  },
});

export const { filterUser,user } = users.actions;

export default users.reducer;
